import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {TrackAdvancedGroupLazy} from "@containers/map/containers/trackAdvancedGroup/TrackAdvancedGroup.lazy";


const TrackAdvancedGroupPage = () => {
    return (
        <PageLayout
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <TrackAdvancedGroupLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default TrackAdvancedGroupPage;